import type { FC, SVGProps } from 'react'

export const Compressor: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 3C2.25 2.58579 2.58579 2.25 3 2.25H21C21.4142 2.25 21.75 2.58579 21.75 3C21.75 3.41421 21.4142 3.75 21 3.75H3C2.58579 3.75 2.25 3.41421 2.25 3Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 21C2.25 20.5858 2.58579 20.25 3 20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21Z"
      fill="currentColor"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V6C11.25 5.58579 11.5858 5.25 12 5.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 8.25C6.41421 8.25 6.75 8.58579 6.75 9V15C6.75 15.4142 6.41421 15.75 6 15.75C5.58579 15.75 5.25 15.4142 5.25 15V9C5.25 8.58579 5.58579 8.25 6 8.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 7.25C15.4142 7.25 15.75 7.58579 15.75 8V16C15.75 16.4142 15.4142 16.75 15 16.75C14.5858 16.75 14.25 16.4142 14.25 16V8C14.25 7.58579 14.5858 7.25 15 7.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 10.25C9.41421 10.25 9.75 10.5858 9.75 11V13C9.75 13.4142 9.41421 13.75 9 13.75C8.58579 13.75 8.25 13.4142 8.25 13V11C8.25 10.5858 8.58579 10.25 9 10.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9.25C18.4142 9.25 18.75 9.58579 18.75 10V14C18.75 14.4142 18.4142 14.75 18 14.75C17.5858 14.75 17.25 14.4142 17.25 14V10C17.25 9.58579 17.5858 9.25 18 9.25Z"
      fill="currentColor"
    />
  </svg>
)
